module.exports = __webpack_public_path__ + "static/media/leftArrowIcon.e9409c6d.svg";